module.exports = function(data) {
var __t, __p = '', __e = _.escape;
__p += '<input type="text" class="query-builder-text-input" value="' +
__e( data.qualifiers ) +
'" placeholder="Start typing to add filters" />\n';
return __p
}